<div class="buttons-holder app-content">
    <div class="btnNav">
        <button
            mat-button
            mat-raised-button
            type="button"
            (click)="changeTableView(2)"
            [ngClass]="{ tabSelected: activeTab == 2 }"
        >
            Bet settings
        </button>
    </div>
    <div class="btnNav">
        <button
            mat-raised-button
            color="primary"
            class="start-button"
            *ngIf="showStartButton"
            (click)="showStartMessage()"
        >
            START
        </button>
        <button
            mat-raised-button
            color="warn"
            class="stop-button"
            *ngIf="showStopButton"
            (click)="showStopMessage()"
        >
            STOP
        </button>
    </div>

    <app-confirm-dialog
        [(visible)]="confirmationVisible"
        [message]="confirmationMessage"
        (confirmed)="onConfirmAction()"
    ></app-confirm-dialog>
</div>

<div class="content-container">
    <div class="left">
        <app-bet-settings *ngIf="activeTab == 2"></app-bet-settings>
    </div>
</div>
